// Polite "temporarily unavailable" notice (ServiceNotice) and the WhatsApp fallback of the checkout.
export default {
  notice: {
    "title": "Serviço temporariamente indisponível",
    "message": "No momento, {{what}} não está funcionando. Pedimos, por gentileza, que entre em contato conosco pelo WhatsApp para confirmar sua reserva — nossa equipe responde rapidamente.",
    "whatsapp": "Confirmar pelo WhatsApp",
    "retry": "Tentar novamente",
    "hint": "Pedimos desculpas pelo inconveniente.",
    "what": {
      "payment": "o pagamento online",
      "booking": "a reserva online desta data",
      "seats": "a reserva online deste passeio",
      "tour": "esta página do passeio",
      "page": "esta página",
      "generic": "este serviço"
    },
    "fallback": {
      "title": "Confirme sua reserva pelo WhatsApp",
      "preflight": "No momento, o pagamento online por Pix não está disponível. Para não perder sua vaga, confirme a reserva diretamente com nossa equipe pelo WhatsApp — enviamos todos os dados para você.",
      "failed": "Não foi possível concluir o pagamento online neste momento. Para garantir sua vaga, confirme a reserva diretamente com nossa equipe pelo WhatsApp — enviamos todos os dados para você.",
      "point1": "Passeio, data e participantes já vão na mensagem",
      "point2": "Nossa equipe confirma a disponibilidade e o pagamento com você",
      "point3": "Sua reserva fica registrada com um código",
      "cta": "Confirmar reserva pelo WhatsApp",
      "autoOpening_one": "Abrindo o WhatsApp em {{count}} segundo…",
      "autoOpening_other": "Abrindo o WhatsApp em {{count}} segundos…",
      "stay": "Prefiro ficar aqui",
      "autoCancelled": "Abertura automática cancelada. Use o botão abaixo quando quiser.",
      "retryOnline": "Tentar o pagamento online novamente"
    }
  },
};
